import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from 'react-redux';
import TranslationProvider from '../../providers/TranslationProvider';
import Button from '../Button';
import Link from '../Link';

import { selectIsAuthenticated } from '../../reducers/authTokenSlice';
import { redirectToSanitizedUrl } from '../../utils/sanitizeTargetUrl';

import './SeeAllPlatinumNightsCard.scss';

const SeeAllPlatinumNightsCard = (props) => {
  const {
    image,
    name,
  } = props;

  const handleSeeAllClick = () => {
    redirectToSanitizedUrl('/platinum', true);
  };

  const renderLinkAndHeading = () => (
    <Link
      onClick={handleSeeAllClick}
      tabIndex="0"
      variant="article"
    >
      <h2
        className={cx('SeeAllPlatinumNightsCard__wrapper__content__info__name skeleton', {
          'no-skeleton': name,
        })}
      >
        {name}
      </h2>
    </Link>
  );

  const renderButtons = () => (
    <TranslationProvider translationKey="button_all_platinum_nights">
      <Button md className="SeeAllPlatinumNightsCard__wrapper__content__button" onClick={handleSeeAllClick}>
        See All Platinum Nights
      </Button>
    </TranslationProvider>
  );

  return (
    <div className="SeeAllPlatinumNightsCard__wrapper">
      <div
        alt=""
        className="SeeAllPlatinumNightsCard__wrapper__image"
        style={{
          backgroundImage: `url(${image})`,
        }}
      />

      <div className="SeeAllPlatinumNightsCard__wrapper__content">
        <div className="SeeAllPlatinumNightsCard__wrapper__content__info">
          {renderLinkAndHeading()}
        </div>

        {renderButtons()}
      </div>
    </div>
  );
};

SeeAllPlatinumNightsCard.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
};

SeeAllPlatinumNightsCard.defaultProps = {
  image: undefined,
  name: null,
};

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
});

SeeAllPlatinumNightsCard.displayName = 'SeeAllPlatinumNightsCard';
export { SeeAllPlatinumNightsCard as ComponentUnderTest };
export default connect(mapStateToProps)(SeeAllPlatinumNightsCard);
